import { createBrowserRouter } from "react-router-dom";
import { PrivateRoute } from "../pages/private/privateRoute";
import NavbarFooterContainer from "../components/common/NavbarFooterContainer/NavbarFooterContainer";
import HomePage from "../pages/Home/home";
import { LoginPage } from "../pages/Login/loginpage";
import { RegisterPage } from "../pages/Register/registerpage";
import { ForgotPasswordPage } from "../pages/PasswordReset/forgotPassword";
import NotAuthorizedPage from "../components/NotAuthorizedPage";
import AdminPanel from "../pages/Admin/AdminPanel";
import ProfilePage from "../pages/Profile/ProfilePage";
import CreateEvent from "../pages/Events/createEvent";
import EventDetailPage from "../pages/Events/eventDetailPage";
import EditEventPage from "../pages/Events/editEventPage";
import SessionCreatePage from "../pages/Sessions/SessionCreatePage";
import SessionListPage from "../pages/Sessions/SessionListPage";
import SessionViewPage from "../pages/Sessions/SessionViewPage";
import SessionEditPage from "../pages/Sessions/SessionEditPage";
import SessionSchedulerPage from "../pages/Sessions/SessionSchedulerPage";
import TermsAndConditions from "../pages/Legal/TermsAndConditions";
import PrivacyPolicy from "../pages/Legal/PrivacyPolicy";

export interface Page {
  name: string;
  path?: string;
  permission?: string;
  children?: Page[];
}

/*
  for dropdowns, add children to pages
  for dropdowns where the parent is also a link, add a path to the parent, to exclude it from the dropdown empty path or remove path variable
  for regular nav links, add a path to the page but no children
*/
export const regularPages: Page[] = [
  { name: 'Home', path: '/'},
  {
    name: 'Events', path: '', permission: 'ADMIN',
    children: [
      { name: 'Create Event', path: '/event/create', permission: 'ADMIN' },
    ]
  },
];

export const settingsPages: Page[] = [
  { name: 'Profile', path: '/profile', permission: 'USER' },
  { name: 'Admin Panel', path: '/adminpanel', permission: 'ADMIN' },
  { name: 'Logout', path: '/login', permission: 'USER' },
];

export const router = createBrowserRouter([
  {
    path: "/",
    element: <NavbarFooterContainer />,
    errorElement: <NotAuthorizedPage />,//change to 404 page
    children: [
      { path: "", element: <HomePage /> },
      { path: "not-authorized", element: <NotAuthorizedPage /> }, //maybe not neccecary as path
      { path: "login", element: <LoginPage /> },
      { path: "register", element: <RegisterPage /> },
      { path: "forgot-password", element: <ForgotPasswordPage /> },
      { path: "event/:eventId", element: <EventDetailPage /> },
      { path: "terms-and-conditions", element: <TermsAndConditions /> },
      { path: "privacy", element: <PrivacyPolicy /> },
      {
        path: "",
        element: (<PrivateRoute />),
        errorElement: <NotAuthorizedPage />,
        children: [
          { path: "session/create/:eventId", element: <SessionCreatePage /> },
          { path: "session/view/:sessionId", element: <SessionViewPage /> },
          { path: "session/edit/:sessionId", element: <SessionEditPage /> },
          { path: "sessionlist/:eventId", element: <SessionListPage /> },
          { path: "event/planner/:eventId", element: <SessionSchedulerPage /> },
          { path: "event/create", element: <CreateEvent /> },
          { path: "event/edit/:eventId", element: <EditEventPage /> },
          { path: "profile", element: <ProfilePage /> },
          { path: "adminpanel", element: <AdminPanel /> },
        ],
      },
    ],
  },

]);

export default router;
